
import React from 'react';
import { useFilters } from '../../context/FilterContext';
import StoreInfoCard from '../cards/StoreInfoCard';
import FilterPanel from '../filters/FilterPanel';
import KpiCardsGroup from '../cards/KpiCardsGroup';
import MonthlyOpenSalesChart from '../charts/MonthlyOpenSalesChart';
import DiningGroupChart from '../charts/DiningGroupChart';
import DiningBehaviorChart from '../charts/DiningBehaviorChart';
import MenuGroupChart from '../charts/MenuGroupChart';
import DailySalesChart from '../charts/DailySalesChart';
import HourlySalesChart from '../charts/HourlySalesChart';
import TopBottomItemsChart from '../charts/TopBottomItemsChart';
import MenuCategoryTrendChart from '../charts/MenuCategoryTrendChart';
import ReviewTrendChart from '../charts/ReviewTrendChart';
import FloatingFilterTooltip from '../filters/FloatingFilterTooltip';
import './DashboardLayout.css';

const DashboardLayout: React.FC = () => {
  const { isLoadingDefaultDates } = useFilters();

  
  if (isLoadingDefaultDates) {
    return (
      <div className="dashboard-layout">
        <div className="filter-loading">
          <div className="loading-spinner"></div>
          <p>기본 설정을 불러오는 중...</p>
        </div>
      </div>
    );
  }

  
  return (
    <div className="dashboard-layout">
      <div className="dashboard-container">
        <StoreInfoCard />
        <FilterPanel />
        {}
        <KpiCardsGroup />
        <MonthlyOpenSalesChart />
        <DiningGroupChart />
        <DiningBehaviorChart />
        <DailySalesChart />
        <HourlySalesChart />
        <MenuGroupChart />
        <TopBottomItemsChart />
        <MenuCategoryTrendChart />
        <ReviewTrendChart />
      </div>
    </div>
  );
};

export default DashboardLayout;